module.exports = __webpack_public_path__ + "img/profile_sp.64af9dbe.png";